const vesselData = {
    name: 'vesselData', // Model name
    state: {}, // Initial state
    reducers: {
        setVesselData(state, payload) {
            return { ...state, [payload.entityKey]: payload }; // Return the updated state with the new payload
        },
    },
};

export default vesselData;
